module.exports = __webpack_public_path__ + "static/tl-2-71b7cb030ef6f24baaf15edd59f61d26.png";